import BootstrapCard from "@nkr/components/bootstrap-card";
import { useInvoiceBackgroundTask } from "@nkr/models/finance/task/invoice-background-task";
import * as moment from "moment";
import { useEffect, useRef } from "react";

export const BackgroundTaskInvoices = () => {
    const api      = useInvoiceBackgroundTask();
    const response = api.useGetData();
    const starter  = api.initiate;

    const detail   = response?.payload || { lastRunDateTime: "N/A", lastRunStatus: "N/A", percentComplete: "N/A" };
    const runDate  = moment.utc(detail.lastRunDateTime).local().format("MM/DD @ h:mmA") || "N/A";

    // Keep a ref to the latest api so the effect doesn't need `api` in its deps
    const apiRef = useRef(api);
    apiRef.current = api;

    const generateInvoices = () => {
        if( confirm("Are you sure you want to generate all invoices?") ) {
            starter({id:0});
        }
    }

    useEffect(() => {
        let timer: number | null = null;
        let stopped = false;

        const poll = async () => {
            try {
                await apiRef.current.refresh?.();
            } catch {
                // a failed request ends the loop instead of retrying every 30s forever;
                // the fetch layer has already toasted the error
                return;
            }
            if (stopped) return;
            timer = window.setTimeout(poll, 30000);
        };

        // first refresh happens 30s after mount, not immediately
        timer = window.setTimeout(poll, 30000);

        return () => {
            stopped = true;
            if (timer) clearTimeout(timer);
        };
    }, []); // run once on mount only

    return (
        <div className="well well-sm">
            <div className="row">
                <div className="col-xs-12">
                    <table>
                        <tbody>
                            <tr>
                                <td style={{ width: 150, verticalAlign: "middle" }} rowSpan={3}>
                                    <button className="btn btn-primary" onClick={generateInvoices}>Generate All</button>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: 150 }}><strong>Last Run Started:</strong></td>
                                <td style={{ width: "auto"}}>{runDate}</td>
                            </tr>
                            <tr>
                                <td style={{ width: 150 }}><strong>Status: <span className="label label-default">{detail.percentComplete}</span></strong></td>
                                <td style={{ width: "auto"}}><span className="label label-info">{detail.lastRunStatus}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};